import 'css-chunksrc/client/scenes/addPlanzoneResourceToProjects/projectsSelection/styles.scss';export default {
  "projectsSelection": "_projectsSelection_1wq4i_1",
  "root": "_root_1wq4i_12",
  "search": "_search_1wq4i_18",
  "list": "_list_1wq4i_22"
};